import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

interface Media {
    name: string;
    url: string;
    createdAt: string;
    updatedAt: string;
}

const containerAll = document.querySelector('[data-id=containerAll]');
if (!containerAll) throw new Error('Container element not found');
const rootAll = createRoot(containerAll);

const container3 = document.querySelector('[data-id=container3]');
if (!container3) throw new Error('Container element not found');
const root3 = createRoot(container3);

rootAll.render(<Newsletter />);
root3.render(<Newsletter type='last-3' />);

interface NewsletterProps {
    type?: 'all' | 'last-3';
}

function Newsletter({ type = 'all' }: NewsletterProps) {
    const apiUrl = import.meta.env.VITE_API_URL || 'https://localhost';
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);

    const [newsletters, setNewsletters] = useState<Media[]>([]);

    useEffect(() => {
        const fetchNewsletters = async () => {
            try {
                const data: Media[] = (await axios.get(`${apiUrl}/api/media/newsletter`)).data;
                if (type === 'last-3') {
                    setNewsletters(data
                        .toSorted((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                        .slice(0, 3)
                    );
                    return;
                }
                setNewsletters(data
                    .toSorted((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                    .slice(3)
                );
            }
            catch (error: any) {
                setError(true);
            }
            finally {
                setLoading(false);
            }
        };

        fetchNewsletters();
    }, []);

    const forceDownload = useCallback(async (url: string, filename: string) => {
        const response = await fetch(url); // credentials si nécessaire
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        a.click();

        window.URL.revokeObjectURL(blobUrl);
    }, []);

    if (loading) {
        return <p className="text-informative loading">Chargement</p>;
    }

    if (error) {
        return <p className="text-informative error">Une erreur est survenue pendant le chargement. Veuillez réessayer plus tard.</p>;
    }

    if (newsletters.length === 0) {
        return <p className="italic text-gray-600">Aucun {type === 'all' ? 'autre' : ''} bulletin d'information disponible pour le moment.</p>;
    }

    return (
        type === 'last-3' ?
            <div className="flex flex-col gap-2">
                {
                    newsletters.map((media, index) => {
                        const downloadUrl = apiUrl + "/uploads/" + media.url;
                        const filename = media.name.replace(/\s+/g, '_').toLowerCase();
                        return <div className="flex items-center gap-4 py-2 px-4 rounded-lg bg-amber-50 border-1 border-amber-200 drop-shadow-md" key={index}>
                            <img src="/assets/img/icons/newspaper.png" alt="Bulletin d'information" className="w-16 h-16 object-cover rounded-lg" />
                            <div className="flex flex-col gap-1">
                                <h3>{media.name}</h3>
                                <span className="text-sm italic text-gray-600">Mis en ligne le {new Date(media.createdAt).toLocaleDateString()}</span>
                                <a href="#" className="bigLink" onClick={() => forceDownload(downloadUrl, filename)}>Télécharger</a>
                            </div>
                        </div>;
                    })
                }
            </div>
            :
            <div className="flex flex-col gap-2">
                {
                    newsletters.map((media, index) => {
                        const downloadUrl = apiUrl + "/uploads/" + media.url;
                        const filename = media.name.replace(/\s+/g, '_').toLowerCase();
                        return <div className="flex items-center gap-4 py-2 px-4 rounded-lg bg-amber-50 border-1 border-amber-200 drop-shadow-md" key={index}>
                            <img src="/assets/img/icons/newspaper.png" alt="Bulletin d'information" className="w-12 h-12 object-cover rounded-lg" />
                            <div className="flex flex-col">
                                <h3 className="text-md">{media.name}</h3>
                                <a href="#" className="font-bold text-purple-500" onClick={() => forceDownload(downloadUrl, filename)}>Télécharger</a>
                            </div>
                        </div>;
                    })
                }
            </div>
    );
}